function addCartItem(itemId, quantity, goToCheckout = false) {
  showAddToCartButtonSpinner();

  const productProperties = {};
  const simpleBundlesProperties = getSimpleBundleProperties();

  if (simpleBundlesProperties) {
    Object.keys(simpleBundlesProperties).forEach((key) => {
      productProperties[key] = simpleBundlesProperties[key];
    });
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          id: itemId,
          quantity: quantity,
          properties: productProperties,
        },
      ],
    }),
  })
    .then((response) => response.json())
    .then((cart) => {
      setTimeout(() => {
        hideAddToCartButtonSpinner();

        if (goToCheckout) {
          window.location.href = window.location.href = '/checkout';
        }
      }, 500);
    })
    .catch((error) => {
      console.error('Add item to cart: [error]:', error);
    });
}

// utils

function showAddToCartButtonSpinner() {
  const { addToCartButton } = getCartElements();

  if (addToCartButton) {
    addToCartButton.classList.add('button--is-loading');
  }
}

function hideAddToCartButtonSpinner() {
  const { addToCartButton } = getCartElements();

  if (addToCartButton) {
    addToCartButton.classList.remove('button--is-loading');
  }
}

function disableCheckoutButton() {
  const { cartOffcanvasCheckoutButton } = getCartElements();

  if (cartOffcanvasCheckoutButton) {
    cartOffcanvasCheckoutButton.disabled = true;
  }
}

function enableCheckoutButton() {
  const { cartOffcanvasCheckoutButton } = getCartElements();

  if (cartOffcanvasCheckoutButton) {
    cartOffcanvasCheckoutButton.disabled = false;
  }
}

function getCartElements() {
  return {
    addToCartButton: document.querySelector('.add-to-cart__add-to-cart-button'),
  };
}

function getSimpleBundleProperties() {
  const properties = {};
  const selects = document.querySelectorAll('#simple-bundles-io-options select[name*="properties"]');

  selects.forEach((select) => {
    const name = select?.name;
    const value = select?.value;

    const match = name?.match(/\[(.*?)\]/);
    if (!match || !value) return;

    const key = match[1];
    properties[key] = value;
  });

  return properties;
}

function updateCartCount(count) {
  const cartCountElements = document.querySelectorAll('.header__quick-link-count');

  if (cartCountElements && cartCountElements.length > 0) {
    cartCountElements.forEach((element) => {
      element.textContent = count;
    });
  }
}

/* upcart */

window.upcartOnCartUpdated = (cart) => {
  updateCartCount(cart.item_count);
};
